export const FILTER_IDS = Object.freeze({
  DATE: 'date',
  FOLDER: 'folder',
  TAGS_UPLOAD: 'tags_upload',
  TAGS_FILE_SET: 'tags_file_set',
  TAGS_WAFER_MAP: 'tags_wafer_map',
  USE_CASE: 'use_case',
  BOOKMARK: 'bookmark',
  MORE: 'more',
  WAFER: 'wafer',
  MODEL: 'model',
  MODEL_STATUS: 'model_status',
  DEFECTS: 'defects',
  GROUND_TRUTH: 'ground_truth',
  WAFER_STATUS: 'wafer_status',
  WAFER_TYPE: 'is_adc_enabled',
  REVIEWED: 'reviewed',
  DEFECT_TYPE: 'is_killer',
  IMAGE_TAG: 'image_tag',
  EXCLUDED_IMAGE_TAG: 'excluded_image_tag',
  AUTO_CLASSIFIED: 'auto_classified',
  AI_OUTPUT: 'ai_output',
  TRAINING_TYPE: 'training_type',
  LOT_ID: 'lot_id',
  TRAINING_LABEL: 'training_label',
  INGEST_STATUS: 'ingest_status',
  IS_LIVE: 'is_live',
} as const);

export type FilterId = (typeof FILTER_IDS)[keyof typeof FILTER_IDS];
